//Polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";
import LocationUtils from "./util/location-utils";

import * as Sentry from '@sentry/browser';

//Custom modules required everywhere
require("./modules/nav-mobile");
require("./modules/nav-desktop");
require("./modules/nav-footer");
require("./util/smoothscroll-anchors");
require("./util/inputs");

//Inline imports to page-specific scripts
//to facilitate code splitting
document.addEventListener('DOMContentLoaded', () => {
    const zipCodeInput = document.querySelector('.zip-entry input[type="search"]');
    if (zipCodeInput && zipCodeInput.value && !document.cookie.split('; ').some(cookie => cookie.startsWith('zip_code='))) {
        LocationUtils.writeZipCookie(zipCodeInput.value);
    }

    Sentry.init({
        dsn: "https://73290b84ebd230f3365968a561336a13@o4506074179174400.ingest.sentry.io/4506152112816128",

        allowUrls: [
            'malarkeyroofing.com',
        ],
        sampleRate: 0.1,
        ignoreErrors: [
            // Random plugins/extensions
            'top.GLOBALS',
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            'originalCreateNotification',
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'http://tt.epicplay.com',
            'Can\'t find variable: ZiteReader',
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            // Facebook borked
            'fb_xd_fragment',
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
            // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
            'bmi_SafeAddOnload',
            'EBCallBackMessageReceived',
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            'conduitPage',
            // Generic error code from errors outside the security sandbox
            // You can delete this if using raven.js > 1.0, which ignores these automatically.
            'Script error.',
            'Event `CustomEvent` (type=error) captured as exception',
            "The play() request was interrupted by",
            "play() failed because the user",
            "The fetching process for the media resource was aborted by the user agent at the user's request",
            "not allowed by the user agent or the platform in the current context, possibly because the user denied permission",
            "The URL is not available because of the video’s privacy settings",
            "plyr/dist/plyr",
            "maps/api/js",
            "ResizeObserver loop completed with undelivered notifications",
            "roof-designer",
            "api/player",
            "Unexpected token '...'. Expected a property name",
            "player.embed.getVideoUrl"
        ],
        denyUrls: [
            // Facebook flakiness
            /graph\.facebook\.com/i,
            // Facebook blocked
            /connect\.facebook\.net\/en_US\/all\.js/i,
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Other plugins
            /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
        ]
    });

    if(document.querySelector('.front-page')) {
        import('./pages/front-page').then( ({ FrontPage }) => {
            window.frontPage = new FrontPage(document.querySelector('.front-page'));
        });
    }

    if(document.querySelector('.why-malarkey')) {
        import('./pages/why-malarkey').then(({WhyMalarkey}) => {
            window.whyMalarkey = new WhyMalarkey(document.querySelector('.why-malarkey'));
        });
    }

    if(document.querySelector('.single')) {
        import('./pages/single').then(({Single}) => {
            window.single = new Single(document.querySelector('.single'));
        });
    }

    if(document.querySelector('.archive')) {
        import('./pages/archive').then(({Archive}) => {
            window.archive = new Archive(document.querySelector('.archive'));
        });
    }

    if(document.querySelector('.page-template-default')) {
        import('./pages/default').then(({DefaultPageTemplate}) => {
            window.single = new DefaultPageTemplate(document.querySelector('.page-template-default'));
        });
    }

    if(document.querySelector('.site__content .single-product')) {
        import('./pages/single-product').then(({SingleProduct}) => {
            window.singleProduct = new SingleProduct(document.querySelector('.site__content .single-product'));
        });
    }

    if(document.querySelector('.single-company')) {
        import('./pages/single-company').then(({SingleCompany}) => {
            window.singleCompany = new SingleCompany(document.querySelector('.single-company'));
        });
    }

    if(document.querySelector('.page-gallery')) {
        import('./pages/page-gallery').then(({GalleryPage}) => {
            window.single = new GalleryPage(document.querySelector('.page-gallery'));
        });
    }

    if(document.querySelector('.page-documents-resources')) {
        import('./pages/page-documents-resources').then(({DocumentsPage}) => {
            window.single = new DocumentsPage(document.querySelector('.page-documents-resources'));
        });
    }

    if(document.querySelector('.find-a-page')) {
        import('./pages/find-a-page').then(({FindAPage}) => {
            window.findAPage = new FindAPage(document.querySelector('.find-a-page'));
        });
    }

    if(document.querySelector('.submit-warranties')) {
        import('./pages/submit-warranties').then(({SubmitWarranties}) => {
            window.submitWarranties = new SubmitWarranties(document.querySelector('.submit-warranties'));
        })
    }

    if(document.querySelector('.page-search')) {
        import('./pages/page-search').then(({SearchPage}) => {
            window.single = new SearchPage(document.querySelector('.page-search'));
        });
    }

    if(document.querySelector('.announcement')) {
        import('./modules/announcement').then(({Announcement}) => {
            window.announcement = new Announcement(document.querySelector('.announcement'));
        });
    }

    if(document.querySelector('.contractor-warranties')) {
        import('./pages/contractor-warranties').then(({ContractorWarranties}) => {
            window.contractorWarranties = new ContractorWarranties(document.querySelector('.contractor-warranties'));
        });
    }

});